import { Box, Typography } from "@mui/material";
import { useTheme } from "../../components/context/context";
import BasicTable from "../../components/basicTable/BasicTable";

export default function Block(){
    const {fontSize} = useTheme();
    return(
        <Box sx={{}}>
            <Box sx={{padding: "2px 0 2px 10px", marginTop: "20px", width:"100%"}}>
                 <div style={{fontSize:`${fontSize+0.1}rem`}}>
                 Block Social Audit Resource Persons Contact Details
                 </div>
                 <br/>
                 <div style={{display:"flex", justifyContent:"center", width:"100%"}}>

                    <BasicTable heading={heading} data={data}/>
                 </div>
            </Box>
        </Box>
    )
}
const heading=[
    {
        data:"Sl. No.",
        width:"10%"
    },
    {
        data:"Name",
        width:"30%"
    },
    {
        data:"District",
        width:"20%"
    },
    {
        data:"Email Adress",
        width:"20%"
    },
    {
        data:"Phone No.",
        width:"20%"
    }
]

const data=[
    ["1","Iarilyne Wahlang","South West khasi Hill","brpmssatmawkyrwatmeg@gmail.com","9863736032"],
    ["2","Risakhiat Rymbai","East Jaintia Hills","risakhiatrymbai@gmail.com","8787553218"],
    ["3","Raymond P Myrthong","Eastern West Khasi Hills","--","9362700895"],
    ["4","Justice Paul Lyngdoh","West Jaintia hills","brpmssatnamdong@gmail.com","8131090733"],
    ["5","Aimilaris Nongsiej","West Khasi Hills","aimilarisnongsiej14@gmail.com","6033172948/8256946230"],
    ["6","Brever R Marak","North Garo Hills","brevermarak9@gmail.com","8837403208"],
    ["7","Pynshailang Syiemlieh","West khasi Hills","Pynshaisyiemlieh27@gmail.com","6909119523"],
    ["8","Sangchi Ch Marak","South West Garo Hills","sangchimarak91@gmail.com","7005792029"],
    ["9","Barister Kharkongor","Ri Bhoi","federickkharkongor20@gmail.com","9774796360"],
    ["10","Tengchang R Marak","East Garo Hills","tengchang619@gmail.com","7005262769"],
    ["11","Alex Barnate Sangma","East Garo Hills","95alexsangma@gmail.com","7005942655"],
    ["12","Pynshaibor G Momin","East Garo Hills","pynshaimomin22@gmail.com","7627950156"],
    ["13","Rafiqul alom","West Garo Hills","brpmssattikrikillawgh@gmail.com","6000215457"],
    ["14","Bernard M Sangma","West Garo Hills","brpmssatbatabari@gmail.com","8575482757"],
    ["15","Silbath Steve M Marak","West Garo Hills","brpmssatselsellawgh@gmail.com","8732052490"],
    ["16","Ripok Dokatchi R Marak","West Garo Hills","brpdadenggremssat@gmail.com","8787862719"],
    ["17","Reepalyne Marbaniang","Eastern West Khasi Hills","reemarbanianggmail.com","9366310978"],
    ["18","Ibanylla Diengngan","West Khasi Hills","brp.mssat.rambrai@gmail.com","9366489690"],
    ["19","Hamemanki Synnah","West Jaintia Hills District","hamemanki09@gmail.com","7630965105"],
    ["20","Donald Richard Basaiawmoit","East Khasi Hills","donrichard333@gmail.com","8787598146"],
    ["21","Cherak R Marak","South Garo Hills","baghmarabrpmssat60@gmail.com","6003127675"],
    ["22","Gitalin D Sangma","South Garo Hills","brpmssatrongara58@gmail.com","9366521353"],
    ["23","Jimrybath R Marak","South Garo Hills","jimryrechil987@gmail.com","9366537565"],
    ["24","Darihun War","East Khasi Hills","dariwar749@gmail.com","8014729886"],
    ["25","Idaskhemti Nongkynrih","East Khasi Hills","brpmssatshellaekhd@yahoo.com","9862889187"],
    ["26","Sainborlang Rynjah","East Khasi Hills","brpmssatlaitkrohekhd@yahoo.com","9856230606"],
    ["27","Medapynpaw Kya","West Jaintia Hills District","medapynpawkya26@gmail.com","8787580280"],
    ["28","Larisuk nora lyngdoh","Ri bhoi","larinora14@gmail.com","6909908070"],
    ["29","Lumdingwell Langrin","South West Khasi Hills","lumdinglangrin@gmail.com","7005086640"],
    ["30","Ralyne Lyngdoh Mawphlang","East Khasi Hills","lyngdohralyne@gmail.com","8014785098"],
    ["31","Etilda Lyngdoh","West Khasi Hills","brpmssatrimuliang@gmail.com","8414004402"],
    ["32","Sengkam N Sangma","West Garo Hills","--","9615992113"],
    ["33","Ribalyne Pyngrope","East Khasi Hills","brpmssatmawlaiekh@gmail.com","8974239110"],
    ["34","Joljina R.Sangma","South Garo Hills","joljinasangma27@gmail.com","9862405947"],
    ["35","Wanborlang Malngiang","Ri-Bhoi","--","7628957481"],
    ["36","Iaiteibun Thongney","East Khasi District Hills","brpmssatmawsynramekhd@yahoo.in","9856554429"],
    ["37","Beatify synnah","West jaintia Hills district","beatifysynnah983@gmail.com","9366263071"],
    ["38","Subalyne L Kurbah","West Khasi Hills","brpmssatmawphlangekh@gmail.com","8794548923"],
    ["39","Bansynshar Ksanlah","EAST KHASI HILLS","bansynksanlah11@gmail.com","9862234873"],
    ["40","Biangborlang jyrwa","West khasi hills","brpmssatmrut@gmail.com","8787785307"],
    ["41","Aksanur Islam","West Garo Hills","brpmssatdemdemawgh6868@gmail.com / aksanurislam28@gmail.com","9365694412"],
    ["42","Viivian Benathy M. Sangma","South West Garo Hills","brpmssatzikzakswgh@gmail.com","8416004301"],
    ["43","Monojit Koch","South West Garo Hills","brpdamalgremssat@gmail.com","8414076958"],
    ["44","Mechanborky Siangshai","East Jaintia Hills","brpmssatlumshnong@gmail.com","7005938106"],
    ["45","Banpynshngain Khongngain","East Khasi Hills","banpynshngainkhongngain@gmail.com","7005948443"],
    ["46","Rahul N Sangma","North Garo hills","resubelparabrpngh26@gmail.com","8837438947"],
    ["47","Arkebish Marak","North Garo hills","adokgremssat@gmail.com","7005101301"],
    ["48","Noonchi N Sangma","North Garo hills","--","8472044716"],
    ["49","Ibarisuklang Biam","Ri Bhoi District","eebabiam@gmail.com","--"],
    ["50","Noonchi N Sangma","North Garo hills","--","8472044716"],
    ["51","Bonitha M Sangma","South West Garo Hills","brpmssatpurakhasia@gmail.com","7005206405"],
    ["52","Sengran A Sangma","West Garo Hills","Gambegrebsarpmssatwgh@gmail.com","9366178452"],
    ["53","Kyrmenskhem Shangdiar","East Khasi Hills","brpmssatekh@gmail.com","8787416481"],
    ["54","Kiran P. Marak","South Garo Hills","--","7005344232"],
   
]
